export default __webpack_public_path__ + "static/media/letsikringafindtaegtvedpension.023a3ca0.jpg";